import { render, staticRenderFns } from "./LifeDailyCardOrder.vue?vue&type=template&id=ec0cfef6&scoped=true&"
import script from "./LifeDailyCardOrder.vue?vue&type=script&lang=js&"
export * from "./LifeDailyCardOrder.vue?vue&type=script&lang=js&"
import style0 from "./LifeDailyCardOrder.vue?vue&type=style&index=0&id=ec0cfef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0cfef6",
  null
  
)

export default component.exports